// Presentation only. The backend owns eligibility, assignments and document locks.
export const approvalActionNames = ['actionSubmitApproval', 'actionApproveByRule', 'actionRejectByRule'];
const labels = [
    { vi: 'Trình duyệt', en: 'Submit', fr: 'Soumettre', es: 'Enviar', id: 'Ajukan', ja: '承認申請', zh: '提交审批', ko: '승인 요청', hi: 'अनुमोदन भेजें', ar: 'طلب الموافقة' },
    { vi: 'Duyệt', en: 'Approve', fr: 'Approuver', es: 'Aprobar', id: 'Setujui', ja: '承認', zh: '批准', ko: '승인', hi: 'अनुमोदन', ar: 'موافقة' },
    { vi: 'Từ chối', en: 'Reject', fr: 'Refuser', es: 'Rechazar', id: 'Tolak', ja: '却下', zh: '拒绝', ko: '거절', hi: 'अस्वीकार', ar: 'رفض' }
];
export function mergeApprovalPresentation(items, document, showActions = true) {
    const guarded = [...approvalActionNames, 'actionRelease', 'actionPayAtCounter', 'actionCreateFullPayment', 'actionApplyPaymentSelection', 'actionCreateCAIssue'];
    const result = (items || []).filter(item => !approvalActionNames.includes(item.name) &&
        (!guarded.includes(item.name) || !Array.isArray(document?.actions) || document.actions.some(action => action.name === item.name && action.visible)));
    for (const [index, name] of approvalActionNames.entries()) {
        if (showActions && document?.actions?.some(action => action.name === name && action.visible)) {
            result.push({ name, text: { ...labels[index] }, icon: index === 2 ? 'close' : 'check', waiting: true, widget: 'Button' });
        }
    }
    return result;
}
